











import { defineComponent, toRefs } from '@nuxtjs/composition-api'
import { DYNAMIC_FORM_FIELD_PROPS } from '~/constants/dynamic-form'
import { useDynamicForm } from '~/compositions/dynamic-form'
import { useDeps } from '~/compositions/dependency-container'
import FormValidationBuilder from '~/builders/form/FormValidationBuilder'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'

export default defineComponent({
  components: { CFormError },
  props: DYNAMIC_FORM_FIELD_PROPS,
  setup(props) {
    const { name, min, max } = toRefs(props)

    const { value, error, changeValue } = useDynamicForm(props)
    const [formValidationBuilder] = useDeps(FormValidationBuilder)

    function handleInput(text: string) {
      error.value = formValidationBuilder
        .new()
        .minChars(min.value, text)
        .maxChars(max.value, text)
        .validate()
      changeValue(name.value, text)
    }

    return { handleInput, value, error }
  }
})
